import React from "react";
import { type IColumn } from "@fluentui/react";
import { type UUID } from "../../utils/uuid";
import { observer } from "mobx-react";
import { computed, makeObservable } from "mobx";
import { type PedestrianDevice } from "../../api";

interface ListPedestrianDeviceItemCellProps {
    readonly pedestrianDeviceId: UUID;
    readonly column: IColumn;
}
import { store } from "../../store";

@observer
export class ListPedestrianDeviceItemCell extends React.Component<ListPedestrianDeviceItemCellProps> {
    constructor(props: ListPedestrianDeviceItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get pedestrianDevice(): PedestrianDevice | undefined {
        return store.repositoryPedestrianDevices.byId(this.props.pedestrianDeviceId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        if (!this.pedestrianDevice) {
            return <></>;
        }
        switch (column.key) {
            case "hardwareSerialNumber":
                return <span>{this.pedestrianDevice.hardwareSerialNumber}</span>;
            case "label":
                return <span>{this.pedestrianDevice.label}</span>;
            case "networkId":
                return <span>{this.pedestrianDevice.networkId}</span>;
            default:
                return <></>;
        }
    }
}
